/* -- Angular Dependencies -- */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
/* -- 3rd party Dependencies -- */
import { TranslateModule, TranslateService } from '@ngx-translate/core';
/* -- Custom Services -- */
import { translateHttpLoaderProviders } from './core/i18n/loader';
/* -- Custom Components -- */
import { AppComponent } from './app.component';
/* -- Custom Modules -- */
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { SystemAdminModule } from './modules/system-admin/system-admin.module';
import { AdminModule } from './modules/admin/admin.module';
import { HeaderModule } from './modules/header/header.module';

import { CONFIG } from './config';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {XFORMModule} from './xform-compat';
declare let $: any;
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';

const oktaAuth = new OktaAuth({
    issuer: environment.okta.issuer,
    clientId: environment.okta.clientId,
    redirectUri: window.location.origin + environment.okta.callbackUrl,
  });

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        OktaAuthModule.forRoot({ oktaAuth }),
        BrowserModule,
        CoreModule,
        TranslateModule.forRoot(),
        XFORMModule.forRoot({
            configFile: CONFIG,
            translationService: TranslateService
        }),
        AuthenticationModule,
        DashboardModule,
        // QueryPanelModule,
        // ResultPanelModule,
        HeaderModule,
        SystemAdminModule,
        AdminModule,
        AppRoutingModule // always AppRoutingModule at the end
    ],
    providers: [
        provideZoneChangeDetection(),
        provideHttpClient(withInterceptorsFromDi()),
        translateHttpLoaderProviders
    ],
    exports: [
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
